/**
 * ProtectedRoute.js - Garde de route pour les pages authentifiées
 * 
 * Comportement:
 * - LOADING: Affiche un spinner
 * - AUTHENTICATED: Rend les enfants
 * - UNAUTHENTICATED: Redirige vers la page d'accueil
 */

import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, AUTH_STATE } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { authState } = useAuth();
  const location = useLocation();

  useEffect(() => {
    console.log(`[ProtectedRoute ${Date.now()}] authState=${authState}, path=${location.pathname}`);
  }, [authState, location.pathname]);

  // Afficher un spinner pendant le chargement
  if (authState === AUTH_STATE.LOADING) {
    console.log(`[ProtectedRoute ${Date.now()}] LOADING state - showing spinner`);
    return (
      <div className="min-h-screen bg-black-rich flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-gold-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-zinc-400">Vérification de la session...</p>
        </div>
      </div>
    );
  }

  // Rediriger si non authentifié
  if (authState === AUTH_STATE.UNAUTHENTICATED) {
    console.log(`[ProtectedRoute ${Date.now()}] UNAUTHENTICATED - REDIRECTING to / from ${location.pathname}`);
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Utilisateur authentifié - rendre les enfants
  console.log(`[ProtectedRoute ${Date.now()}] AUTHENTICATED - rendering children`);
  return children;
}
